import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { NovaOrb } from "../components/NovaOrb";
import { useAuth } from "../context/AuthContext";

export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(email, password, name);
    setLoading(false);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    navigate("/onboarding");
  };

  return (
    <div className="min-h-screen bg-kaizen-bg flex flex-col items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_50%_0%,rgba(139,93,199,0.16),transparent_60%)]" />
      <Link to="/" className="mb-6">
        <NovaOrb size={80} />
      </Link>
      <h1 className="font-display text-3xl text-kaizen-text mb-2">Meet Nova</h1>
      <p className="text-sm text-kaizen-dim mb-8">Small beats zero, starting now.</p>

      <form onSubmit={handleSubmit} className="glass-card w-full max-w-sm rounded-3xl p-7 space-y-4" data-testid="signup-form">
        <div>
          <label className="text-xs text-kaizen-dim tracking-wide">Name</label>
          <input
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            data-testid="signup-name-input"
            className="mt-1.5 w-full bg-white/[0.04] border border-white/[0.09] rounded-xl px-4 py-2.5 text-sm text-kaizen-text outline-none focus:border-kaizen-violet/60 transition-colors duration-300"
          />
        </div>
        <div>
          <label className="text-xs text-kaizen-dim tracking-wide">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="signup-email-input"
            className="mt-1.5 w-full bg-white/[0.04] border border-white/[0.09] rounded-xl px-4 py-2.5 text-sm text-kaizen-text outline-none focus:border-kaizen-violet/60 transition-colors duration-300"
          />
        </div>
        <div>
          <label className="text-xs text-kaizen-dim tracking-wide">Password</label>
          <input
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="signup-password-input"
            className="mt-1.5 w-full bg-white/[0.04] border border-white/[0.09] rounded-xl px-4 py-2.5 text-sm text-kaizen-text outline-none focus:border-kaizen-violet/60 transition-colors duration-300"
          />
        </div>
        {error && (
          <p className="text-xs text-ready-rose" data-testid="signup-error">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={loading}
          data-testid="signup-submit-button"
          className="glow-cta w-full py-3 rounded-full bg-kaizen-violet text-[#140A24] font-semibold text-sm hover:scale-[1.02] active:scale-[0.98] transition-transform duration-300 disabled:opacity-60"
        >
          {loading ? "Creating account…" : "Create account"}
        </button>
      </form>

      <p className="mt-6 text-sm text-kaizen-dim">
        Already have an account?{" "}
        <Link to="/login" data-testid="link-to-login" className="text-kaizen-violetSoft hover:underline">
          Log in
        </Link>
      </p>
    </div>
  );
}
